import store from '../../store';
import { resetAppSessionState } from '../../reducers/app/appReducer';
import { resetSearchSessionState } from '../../reducers/search/searchReducer';
import { resetTimeSlotsSessionState } from '../../reducers/timeslots/timeSlotsReducer';
import { clearContactState } from '../../reducers/contact/contactReducer';
import { clearAvailableServices } from '../../reducers/services/servicesReducer';
import { clearSessionData } from '../../helpers/sessionHelper';

export const resetSessionState = () => {
  store.dispatch(resetAppSessionState());
  store.dispatch(resetSearchSessionState());
  store.dispatch(resetTimeSlotsSessionState());
  store.dispatch(clearContactState());
  store.dispatch(clearAvailableServices());
  clearSessionData();
};
